import { useSwrFetch } from "./useSwrFetch";

export function useShipmentDetailFiles(shipmentId: number | undefined) {
  const url =
    shipmentId !== undefined ? `/shipments/${shipmentId}/detail-files` : null;

  const { data, loading, error, refetch } = useSwrFetch<ShipmentDetailFile[]>({
    url,
    errorMessage:
      "Failed to load shipment files. Please contact us at support@evotrux.com",
  });

  return {
    files: data ?? [],
    loading,
    error,
    refetchFiles: refetch,
  };
}
